import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing, theme} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  formTitle: css`
    min-height: ${spacing(7)};
    padding: ${spacing(2)};
  `,
  plate: css`
    background: #f1f0ed;
    color: black;
    padding: 2px 8px;
    font-size: 13px;
    line-height: 23px;
    white-space: nowrap;
    text-transform: uppercase;
    font-weight: 500;
    border-radius: ${theme.spacing(0.5)}px;
    position: relative;
  `,
  plateCar: css`
    position: absolute;
    display: block;
    width: 56px;
    height: 20px;
    top: calc(100% - 9px);
    right: -10px;
  `,
  plateImage: css`
    position: relative;
    width: 48px;
  `,
  image: css`
    width: 100%;
  `,
  plateNumbers: css`
    font-size: 16px;
    margin: 0 3px;
  `,
  title: css`
    font-size: 20px;
    font-weight: 500;
    line-height: 23px;
  `,
}
